import { useForm } from '@/common/form/FormContext';
import { useFormFieldDef } from '@/common/form/hooks/useFormFieldDef';
import { TextField } from '@mui/material';
import { forwardRef } from 'react';
import { PriceResFormulaContent } from './PriceResFormulaContent';

// Substitutes for the native <input> so the surrounding TextField keeps the standard field styling
// (label, box, disabled coloring) while its content is the tooltipped/hyperlinked formula markup
// id/aria-describedby are forwarded so the InputLabel/helper text stay associated with this field
const FormulaContentInput = forwardRef(function FormulaContentInput(
  { className, id, 'aria-describedby': ariaDescribedBy, formula, vars },
  ref,
) {
  return (
    <div ref={ref} id={id} aria-describedby={ariaDescribedBy} className={className}>
      <PriceResFormulaContent formula={formula} vars={vars} />
    </div>
  );
});

// Read-only display of a PriceRes' tier formula, tooltipping each bracketed var code with the value
// used at eval time (same rendering as PriceResFormulaCellRenderer, adapted to the form's formValues)
export const PriceResFormulaFormField = ({ fieldDef }) => {
  const { formValues } = useForm();
  const { value, label, variant } = useFormFieldDef(fieldDef);

  return (
    <TextField
      variant={variant}
      disabled
      fullWidth
      label={label}
      slotProps={{
        input: {
          inputComponent: FormulaContentInput,
          inputProps: { formula: value, vars: formValues.tierVars },
          // A real <input> never wraps regardless of CSS; our <div> substitute needs this declared
          // explicitly, and overflow-x is scrollable (rather than clipped) so the full formula is reachable
          sx: {
            '& .MuiInputBase-input': {
              whiteSpace: 'nowrap',
              overflowX: 'auto',
            },
          },
        },
      }}
    />
  );
};
